//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Gorlin',
  data() {
    return {
      defaultJson: {
        "Heart Rate": "心率",
        "Tricuspid Valve Area": "三尖瓣面积",
        "Mean Valve Gradient": "平均瓣膜梯度",
        "Mitral": "二尖瓣",
        "Pulmonic Valve Area": "肺动脉瓣面积",
        "Cardiac Output": "心输出量",
        "Mitral Valve Area": "二尖瓣面积",
        "Pulmonic": "肺动脉瓣",
        "Systolic Ejection Period": "收缩射血期",
        "Aortic": "主动脉瓣",
        "Tricuspid": "三尖瓣",
        "Aortic Valve Area": "主动脉瓣面积",
        "Diastolic Filling Period": "舒张充盈期"
      },
      form: {
        method: -1,
        co: '',
        hr: '',
        sep: '',
        dfp: '',
        mvg: '',
      },
      contentDescription: '',
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: -1, name: '二尖瓣' },
        { value: 1, name: '主动脉瓣' },
        { value: -2, name: '三尖瓣' },
        { value: 2, name: '肺动脉瓣' },
      ],
      res: '...',
      activeIndex: 0,

    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(item, index) {
      this.form.method = item.value;
      this.activeIndex = index
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      if (form.method < 0) {
        form.sep = '0'
      } else if (form.method > 0) {
        form.dfp = '0'
      }
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = 0
        if (form.method == -1) {
          result = 1000 * form.co / (37.7 * Math.sqrt(form.mvg) * form.hr * form.dfp)
        } else if (form.method == 1) {
          result = 1000 * form.co / (44.3 * Math.sqrt(form.mvg) * form.hr * form.sep)
        } else if (form.method == -2) {
          result = 1000 * form.co / (37.7 * Math.sqrt(form.mvg) * form.hr * form.dfp)
        } else if (form.method == 2) {
          result = 1000 * form.co / (44.3 * Math.sqrt(form.mvg) * form.hr * form.sep)
        }
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Gorlin.vue